module.exports = __webpack_public_path__ + "static/media/5.0b8c0606.jpg";